
import { showModal } from "./modal/tools/useCustomModal"
import {showModal as showWxSubscribeModal } from "./modal/tools/useWxSubscribeModal"
import { showLoading, hideLoading } from "./loading"
import { showTextEditor } from "./text-editor/tools/useTextEditor"
import { showDatePicker } from "./date-picker"
import { previewImage } from "./preview-image"
import { showHashtagEditor } from "./hashtag-editor/tools/useHashtagEditor"
import { showSnackBar } from "./snack-bar"
import { showActionSheet } from "./action-sheet"
import { showSearchEditor } from "./search-editor/tools/useSearchEditor"
import { showStateSelector } from "./state-selector"
import { showStateEditor } from "./state-editor"
import { showShareView } from "./share-view/tools/useShareView"
import { showContentPanel } from "./content-panel/tools/useContentPanel"
import { showCommentPopup } from "./comment-popup/tools/useCommentPopup"
import { showHashtagSelector } from "./hashtag-selector/tools/useHashtagSelector"
import { showQRCodePopup } from "./qrcode-popup/tools/useQRCodePopup"
import { showBindPopup } from "./bind-popup/tools/useBindPopup"

export default {
  showModal,
  showWxSubscribeModal,
  showLoading,
  hideLoading,
  showTextEditor,
  showDatePicker,
  previewImage,
  showHashtagEditor,
  showHashtagSelector,
  showSnackBar,
  showActionSheet,
  showSearchEditor,
  showStateSelector,
  showStateEditor,
  showShareView,
  showContentPanel,
  showCommentPopup,
  showQRCodePopup,
  showBindPopup,
}